<template>
  <div class="wrapper">
    <modal :show.sync="showEditCompanyModal">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Set Company Details</h5>
      </template>
      <AssignCompany @closeClicked="showEditCompanyModal = false" @saveClicked="alert('ddd')" />
    </modal>
    <notifications />
    <div class="main-content">
      <ProjectNavBar @calendarClicked="handleCalendarClicked()" @userClicked="handleUserClicked()"
        @headerLoginClicked="onHeaderLoginClicked" @detailClicked="handleDetailClicked()" />
      <ProjectsHome  @dblClick="handleTaskDblClick" @taskDblClick="handleTaskDblClick"
        @assignedByUserClicked="handleAssignedByUserClicked" @loginClicked="handleLoginClick"
        :projectCreateFlag="projectCreateFlag" />
      <SidebarRight @overlayClicked="outside" :class="[
        'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400',
        { open: showSideBar }
      ]">
        <component :editId="editId" :showSideBar="showSideBar" :data="data" :profile="profile" :is="currentView" @projectCreated="onProjectCreated"
          @iAmNewClicked="handleIAmNewClicked" @backClickedFromRegister="currentView = 'Login'"
          @backClickedFromForgot="currentView = 'Login'" @forgotPasswordLinkClicked="currentView = 'Forgot'"
          @registerSuccess="onRegisterSuccess" @verificationNeeded="onVerificationNeeded"
          @resetPasswordSuccess="onResetPasswordSuccess" @userVerified="onUserVerificationSuccess" />
      </SidebarRight>
      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import ProjectsHome from "@/app/pages/ProjectsHome.vue";

import ProjectNavBar from "./ProjectNavBar.vue";
import ContentFooter from "./Footer.vue";
import SidebarRight from "./SidebarRight";
import { FadeTransition } from "vue2-transitions";

//sidebar components

import Preference from "@/app/components/Preference.vue";
// import CreateProject from "@/app/components/CreateProject.vue";
import CreateAssetProject from "@/app/components/CreateAssetProject.vue";
import ChangeOwner from "@/app/components/ChangeOwner.vue";
import DetailLog from "@/app/components/DetailLog.vue";
import { mapActions, mapState, mapMutations } from "vuex";

import Login from "@/app/components/Login.vue";
import Register from "@/app/components/Register.vue";
import Verify from "@/app/components/Verify.vue";
import Forgot from "@/app/components/Forgot.vue";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import AssignCompany from "@/app/components/AssignCompany.vue";
import { truncate } from "fs";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    ProjectNavBar,
    ContentFooter,
    FadeTransition,
    SidebarRight,
    ProjectsHome,
    CreateAssetProject,
    Preference,
    DetailLog,
    Login,
    Register,
    Verify,
    Forgot,
    ChangeOwner,
    AssignCompany
  },
  data() {
    return {
      showEditCompanyModal: false,
      editId: null,
      data: null,
      showSideBar: false,
      currentView: "CreateAssetProject",
      projectCreateFlag: false,
      invitation: null
    };
  },


  mounted() {

    console.log(this.$route, "ddddadddddaaddd");
    this.$nextTick(async () => {

      if (this.$route.query.login) {
        this.currentView = "Login";
        this.showSideBar = true;
      }

      setTimeout(() => {


        if (this.profile && this.profile.role.name != "guest") {
          this.$snack.success(
            "Please double click on white area to start a project"
          );
        }
      }, 5000);
    });
  },

  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      console.log("hi before ", to)
      if (!vm.$auth.isAuthenticated()) {
         let email = "demo@andmine.com";
         await vm.initLogin(email);
         await vm.fetchUserInfoAction();
         next()
       
      } else {
        await vm.fetchUserInfoAction()
        console.log(to.name == "projects" , to.query.success == "true", "ha ha this is to")
        if(to.name == "projects" && to.query.success == "true") {
          const approvalTasksStr = localStorage.getItem("approvalTasks");
          //console.log(approvalTasks, "approvaltasks")
          if(approvalTasksStr) {
            const approvalTasks = JSON.parse(approvalTasksStr)
            if(approvalTasks.length > 0) {
              const parentId = approvalTasks[0].parent_id;
              next('/projects/'+parentId+'/?success=true')
            } else {
              next('/')
            }
            
          }
        } else if(to.name == "projects" && to.query.return == "true") { 
          const stripeConnectProjectId = localStorage.getItem("stripe_connect_project");
          //console.log(approvalTasks, "approvaltasks")
          if(stripeConnectProjectId) {
            next('/projects/'+stripeConnectProjectId+'/?return=true')
          }
        }
      }

      await vm.postLoginCheck()
    });
  },

  watch: {},

  async created() {

    document.addEventListener("keyup", evt => {
      if (evt.keyCode === 27) {
        this.outside();
      }
    });
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState(["showFeatured", "showBanner"])
  },

  methods: {
    ...mapActions("user", ["fetchUserInfoAction", "getDemoLogin"]),
    ...mapActions("common", ["fetchInvitation"]),
    ...mapMutations(["setLoading"]),
    ...mapMutations(["setShowFeatured", "setShowBanner"]),

    initLogin(username) {
      const clientId = process.env.VUE_APP_CLIENT_ID;
      const clientSecret = process.env.VUE_APP_CLIENT_SECRET;
      this.setLoading(true);
      return this.$auth
        .login({
          username: username,
          password: "secret",
          client_id: clientId,
          client_secret: clientSecret,
          grant_type: "password"
        })
        .then(r => {
          this.setLoading(false);
          return Promise.resolve(true);
        })
        .catch(e => {
          this.setLoading(false);
          this.$snack.success("Invalid Credentials.");
          return Promise.reject(false);
        });
    },

    async postLoginCheck() {
     
     if (this.profile.role.name == "invite") {
       //logout last invite login and relogin demo
       await this.initLogin(email);
       await this.fetchUserInfoAction();
     }

     //if invition
     if (this.$route.query.login && this.$route.query.token && !this.$auth.isAuthenticated()) {
       try {

         let r = await this.fetchInvitation(this.$route.query.token);
         console.log(r, "aaaa");
         if (r.data) {
           this.invitation = r.data;
           email =
             this.invitation.invitedTo && this.invitation.invitedTo.email;
           let role = this.invitation.invitedTo.role;
           //console.log("roleid", role)
           if (role.name == "invite") {
             await this.initLogin(email);
             await this.fetchUserInfoAction();
             this.$router.replace({
               name: "invite",
               params: { invitation: this.invitation }
               //query: this.$route.query
             });
             return false;
           } else {
             //if not logged in already then show login form
             if (this.profile.role.name == "guest") {
               this.currentView = "Login";
               this.showSideBar = true;
             } else {
               // now user is already logged
               //check if invition is for him
               if (this.invitation) {
                 let currentUserEmail = this.profile.email;
                 if (currentUserEmail != email) {
                   this.$notify({
                     type: "success",
                     message:
                       "You are logged in with different account. Please logout and sign in with correct details."
                   });
                   this.$snack.success(
                     "You are logged in with different account. Please logout and sign in with correct details."
                   );
                   return false;
                 } else {
                   //send him direct to related task
                   let { id, name } = this.invitation.parent
                     ? this.invitation.parent
                     : this.invitation.project;
                   this.$router.push({
                     name: "tasks.quote",
                     params: {
                       id: id,
                       name: name,
                       showThread: this.invitation.parent ? true : false,
                       threadId: this.invitation.project.id,
                       screen: this.invitation.invitation_type
                     }
                   });
                 }
               }
             }
           }
         } else {
           
           this.$snack.success("Invalid Link");

           return false;
         }
       } catch (e) {
         //console.log(e)
       }
     } 
   
 },

    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    

    handleTaskDblClick(id, event, task) {
      if (this.profile.role.name != "guest") {
        console.log("permission", task);
        if (task) {
          if (task.permission && task.permission.edit == 1) {
            this.data = task;
            this.currentView = "CreateAssetProject";
            this.showSideBar = true;
            this.editId = id;
            console.log("sagar", id, task.permission, this.showSideBar);
          } else {
            this.$snack.success("You can not edit this project.");
          }
        } else {
          this.data = null;
          this.currentView = "CreateAssetProject";
          this.editId = null;
          this.showSideBar = true;
        }
      } else {
        this.currentView = "Login";
        this.showSideBar = true;
      }
    },

   

    handleAssignedByUserClicked(id, userId) {
      if (this.profile.role.name != "guest") {
        //console.log(id)
        this.editId = id;
        this.currentView = "ChangeOwner";
        this.showSideBar = true;
      } else {
        this.currentView = "Login";
        this.showSideBar = true;
      }
    },

    handleUserClicked() {
      this.currentView = "Preference";
      this.showSideBar = true;
    },
    handleDetailClicked() {
      this.currentView = "DetailLog";
      this.showSideBar = true;
    },

    onVerificationNeeded() {
      this.currentView = "Verify";
      this.showSideBar = true;
    },



    handleCalendarClicked() {
      alert("calendar");
    },

    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("scrollbar-inner");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },

    handleDblClick() {
      this.currentView = "Another";
      this.showSideBar = true;

      //this.$router.push('/home');
    },

    onProjectCreated() {
      this.showSideBar = false;
      this.projectCreateFlag = !this.projectCreateFlag;
      this.editId = null;
    },

    //login related
    handleLoginClick() {
      this.currentView = "Login";
      this.showSideBar = true;
      //this.$router.push('/home');
    },

    onHeaderLoginClicked() {
      this.currentView = "Login";
      this.showSideBar = true;
    },

    handleIAmNewClicked() {
      this.currentView = "Register";
      this.showSideBar = true;
      //this.$router.push('/home');
    },

    onRegisterSuccess(data) {
      this.currentView = "Verify";
    },

    onResetPasswordSuccess() {
      this.$snack.success("Password has been reset successfully, please login.");
      this.currentView = "Login";
    },

    onUserVerificationSuccess() {
      this.$snack.success(
        "Account has been verified successfully, please login."
      );
      this.currentView = "Login";
    },
    //end of login related

    outside() {
      if (this.showSideBar == true) {
        this.showSideBar = false;
      }
    }
  }
};
</script>
